import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const variants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
  {
    variants: {
      tone: {
        neutral: 'border-border bg-muted text-muted-foreground',
        running: 'border-blue-500/30 bg-blue-500/10 text-blue-700 dark:text-blue-300',
        success: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
        failure: 'border-red-500/30 bg-red-500/10 text-red-700 dark:text-red-300',
        warning: 'border-amber-500/30 bg-amber-500/10 text-amber-700 dark:text-amber-300',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof variants> {}

export function Badge({ className, tone, ...rest }: BadgeProps) {
  return <span className={cn(variants({ tone }), className)} {...rest} />;
}

export function statusTone(status: string): 'neutral' | 'running' | 'success' | 'failure' | 'warning' {
  const s = status.toUpperCase();
  if (s.includes('RUNNING')) return 'running';
  if (s.includes('COMPLETED')) return 'success';
  if (s.includes('FAILED') || s.includes('TIMED_OUT')) return 'failure';
  if (s.includes('CANCELED') || s.includes('TERMINATED')) return 'warning';
  return 'neutral';
}
